import { DocuSignTypes } from "./types"

export const getDocuSignAuthUrlAction = () => ({
  type: DocuSignTypes.GET_DOCUSIGN_AUTH_URL,
})

export const getDocuSignAuthUrlSuccess = payload => ({
  type: DocuSignTypes.GET_DOCUSIGN_AUTH_URL_SUCCESS,
  payload,
})

export const getDocuSignAccessTokenAction = payload => ({
  type: DocuSignTypes.GET_DOCUSIGN_ACCESS_TOKEN,
  payload,
})

export const getDocuSignAccessTokenSuccess = payload => ({
  type: DocuSignTypes.GET_DOCUSIGN_ACCESS_TOKEN_SUCCESS,
  payload,
})